import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CompareService {
  private itemsToCompare: any[] = [];
  private itemsToCompare$: BehaviorSubject<any> = new BehaviorSubject<any>(this.itemsToCompare);
  private requestRemove$: Subject<any> = new Subject<any>();

  public constructor(private router: Router) {
    router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd && event.url !== '/compare') {
        this.itemsToCompare = [];
        this.itemsToCompare$.next(this.itemsToCompare);
      }
    });
  }

  public requestRemove(item: any): void {
    this.requestRemove$.next(item);
  }

  public reset(): void {
    this.itemsToCompare = [];
    this.itemsToCompare$.next(this.itemsToCompare);
  }

  public getRequestRemove$(): Observable<any> {
    return this.requestRemove$;
  }

  public addItemToCompare(item: any): void {
    this.itemsToCompare.push(item);
    this.itemsToCompare$.next(this.itemsToCompare);
  }

  public removeItemToCompare(item: any): void {
    const foundItem: any = this.findItemByName(item.naam);
    if (foundItem) {
      this.itemsToCompare = this.itemsToCompare.filter(entry => entry !== foundItem);
      this.itemsToCompare$.next(this.itemsToCompare);
    }
  }

  public getItemsToCompare$(): Observable<any> {
    return this.itemsToCompare$;
  }

  public findItemByName(name: string): any {
    return this.itemsToCompare.find(element => {
      return element.naam === name;
    });
  }
}
